import { render, staticRenderFns } from "./InsuranceSettings.vue?vue&type=template&id=d97bc0c2&scoped=true&"
import script from "./InsuranceSettings.vue?vue&type=script&lang=ts&"
export * from "./InsuranceSettings.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceSettings.vue?vue&type=style&index=0&id=d97bc0c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97bc0c2",
  null
  
)

export default component.exports